import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import highValueImg from "../../../../assets/imgs/services/nationals/high-value.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function HighValue() {
  const [tHighValue] = useTranslation("highValuePage");
  const [tSMetaData] = useTranslation("metaData");
  const idHighValue = "c25cf9ca-9fcf-4b25-8db0-a9e7bb2bed53";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[4]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[4]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHighValue}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Embalaje y Manejo Especial"]
              .content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Packaging and Special Handling"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("altoValor.title")}</title>
        <meta
          name="description"
          content={tSMetaData("altoValor.description")}
        />
      </Helmet>
      <ImageHeader
        section={tHighValue("header.section")}
        title={tHighValue("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tHighValue("description.content"))
        }
        quoteBtn={tHighValue("header.quote-btn")}
        quoteProductID="btnQuoteValue"
        contactSales={tHighValue("header.contact-sales")}
        contactProductID="btnContactValue"
        imgBackground={highValueImg}
      />

      <Accordion
        title={tHighValue("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tHighValue("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHighValue("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tHighValue("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHighValue("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tHighValue("accordion-3.content"))
        }
      />
    </>
  );
}

export default HighValue;
